import store from "@/config/vuex/store";

export default [
    {
        path: "/sms",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "",
                name: "smsRead",
                component: () => import('@/pages/SMS/SmsRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

